import { createApp } from '@app/adapters/create-app'
import MeetingPreparation from '../screens/preparation/components/meeting-preparation'
import createMeetingPreparationStore from '@app/application/client_meetings/screens/preparation/store/meeting-preparation-store'
import { startOnce } from '@app/adapters/tutorial'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='client-meetings-preparation']").each(function () {
    const store = createMeetingPreparationStore({
      firmId: Silverfin.currentFirmId,
      companyId: Silverfin.currentCompanyId,
    })
    const app = createApp(MeetingPreparation, {
      initialOrder: this.dataset.initialOrder
        .split(',')
        .map((s) => Number.parseInt(s)),
      ledgerId: Number.parseInt(this.dataset.ledgerId),
      ledgerLabel: this.dataset.ledgerLabel,
      suggestionsEnabled: this.dataset.suggestionsEnabled,
    })
    app.use(store)
    app.mount(this)

    startOnce(132023)
  })
})
